/**
 * Plan tiers — frontend mirror of `soleadlab-api/src/shared/plans.ts`.
 * The two copies must stay in sync byte-for-byte (we don't have a build-time
 * symlink; whoever edits one must edit the other).
 *
 * `-1` for any limit means "unlimited".
 */

export type PlanId = 'free' | 'professional' | 'enterprise';

export interface PlanFeatures {
  maxSites: number;
  maxUsers: number;
  maxStorageGb: number;
  scada: boolean;
  iv: boolean;
  advancedAlarms: boolean;
}

export const PLAN_TIERS: Record<PlanId, PlanFeatures> = {
  free: {
    maxSites: 2,
    maxUsers: 3,
    maxStorageGb: 5,
    scada: false,
    iv: false,
    advancedAlarms: false,
  },
  professional: {
    maxSites: 20,
    maxUsers: 15,
    maxStorageGb: 100,
    scada: true,
    iv: true,
    advancedAlarms: true,
  },
  enterprise: {
    maxSites: -1,
    maxUsers: -1,
    maxStorageGb: -1,
    scada: true,
    iv: true,
    advancedAlarms: true,
  },
};

export const PLAN_DISPLAY_ORDER: PlanId[] = ['free', 'professional', 'enterprise'];

export function getPlanFeatures(planId: string | null | undefined): PlanFeatures {
  if (!planId) return PLAN_TIERS.free;
  return PLAN_TIERS[planId as PlanId] ?? PLAN_TIERS.free;
}

export function planLabel(planId: string | null | undefined): string {
  switch (planId) {
    case 'professional': return 'Professional';
    case 'enterprise':   return 'Enterprise';
    case 'free':         return 'Free';
    default:             return 'Free';
  }
}
